import styled from 'styled-components';
import { ContainerBaseModalComment } from '../styles';

export const Container = styled(ContainerBaseModalComment)`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;

  &&& {
    .MuiAutocomplete-root {
      width: 100%;
    }
    .MuiInputBase-root {
      border: 1px solid #d9d9d9;
      width: 100%;
    }
  }
`;

export const AreaDropdowns = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.4rem;
`;

export const AreaTextArea = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;

  gap: 0.4rem;
  width: 100%;
`;
export const AreaMessageReply = styled.div`
  position: relative;

  display: flex;
  -webkit-box-align: center;
  align-items: center;
  padding: 10px 4px;
  font-size: 12px;
  color: rgb(126, 126, 126);
  background-color: rgb(222 229 255);
  border-radius: 0px 6px 6px 0px;
  width: 100%;
  max-width: 300px;
  border-left: 1px solid #3f5ec9;
  margin: 0 0 10px 0;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
`;
export const AreaRemoveReply = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  color: ${({ theme }) => theme.icon};
`;

